/**
 * The value of `promise`, or what `onTimeout` gives when it does not settle
 * within `timeoutMs` (`onTimeout` may throw to reject instead). The timer is
 * cleared once either happens.
 */
export async function withTimeout<TValue, TTimeoutValue>(
  promise: Promise<TValue>,
  timeoutMs: number,
  onTimeout: () => TTimeoutValue
): Promise<TValue | TTimeoutValue> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<TTimeoutValue>((resolve, reject) => {
    timer = setTimeout(() => {
      try {
        resolve(onTimeout());
      } catch (error) {
        reject(error);
      }
    }, timeoutMs);
  });
  try {
    return await Promise.race([promise, timeout]);
  } finally {
    clearTimeout(timer);
  }
}
